
import React from 'react';

const TermsContent_de: React.FC = () => (
    <div className="space-y-4 text-sm leading-relaxed text-slate-700" dir="ltr">
        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">1. Rezept-Eigentum & Zuschreibung</h3>
            <p>
                Durch die Veröffentlichung von Inhalten auf mealPai erkennen Sie an und stimmen zu, dass jedes Rezept, das aus einer externen Quelle (einschließlich, aber nicht beschränkt auf Websites, Kochbücher oder Blogs) hinzugefügt wird und mit der Originalquelle identisch oder im Wesentlichen ähnlich ist, <strong>einen direkten Referenzlink (URL) oder ein Zitat</strong> zum ursprünglichen Ersteller enthalten muss, wenn das Rezept als "Öffentlich" markiert ist.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">2. Nutzerverantwortung & Haftung</h3>
            <p>
                Öffentliche Rezepte, die ohne angemessene Nennung oder Referenz aus einer externen Quelle kopiert werden, können eine Verletzung von geistigen Eigentumsrechten darstellen.
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                    <strong>Nutzerverantwortung:</strong> Der Nutzer, der den Inhalt veröffentlicht, ist allein dafür verantwortlich und rechenschaftspflichtig, sicherzustellen, dass er das Recht hat, den Inhalt zu teilen und die erforderliche Zuschreibung bereitzustellen.
                </li>
                <li>
                    <strong>Haftungsbeschränkung:</strong> mealPai, seine Betreiber, Mitarbeiter, Freiwilligen und Partner (bezahlt oder unbezahlt) werden <strong>nicht verantwortlich oder haftbar gemacht</strong> für Rezepte, die von Nutzern ohne angemessene Nennung oder unter Verletzung von Urheberrechtsgesetzen kopiert, veröffentlicht oder verbreitet werden.
                </li>
            </ul>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">3. Änderungen & Fair Use</h3>
            <p>
                Nutzer werden ermutigt, Änderungen, Anpassungen oder Verbesserungen an Rezepten vorzuschlagen. Solche Vorschläge und veröffentlichten Änderungen müssen jedoch im Rahmen der geltenden Urheberrechtsgesetze bleiben. Eine wesentliche Umwandlung eines Rezepts hebt nicht automatisch die Anforderung der Zuschreibung auf, wenn das Kernwerk von einer geschützten Quelle abgeleitet ist.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">4. Verbotene Inhalte & Verhalten</h3>
            <p>
                Es ist Nutzern strengstens untersagt, Inhalte zu veröffentlichen, die obszöne, beleidigende, rassistische, brutale, hasserfüllte oder anderweitig unangemessene Sprache enthalten.
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                    <strong>Null-Toleranz:</strong> mealPai verfolgt eine Null-Toleranz-Politik gegenüber Belästigung, Hassrede und beleidigenden Inhalten.
                </li>
                <li>
                    <strong>Kontodeaktivierung:</strong> Jeder Nutzer, der für die Veröffentlichung solcher Inhalte verantwortlich ist, wird persönlich zur Rechenschaft gezogen. mealPai behält sich das Recht vor, das Konto eines Nutzers, der gegen diese Richtlinie verstößt, <strong>sofort und ohne vorherige Ankündigung zu deaktivieren</strong>.
                </li>
            </ul>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">5. Entfernung von Inhalten</h3>
            <p>
                mealPai behält sich das Recht vor, übernimmt jedoch nicht die Verpflichtung, Inhalte zu entfernen, die gemeldet oder entdeckt wurden und gegen diese Bedingungen oder geltende Gesetze zum geistigen Eigentum verstoßen, ohne vorherige Ankündigung an den Nutzer.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">6. Preise & Abonnements</h3>
            <p>
                Derzeit wird mealPai kostenlos für Tests und den persönlichen Gebrauch zur Verfügung gestellt. Wir behalten uns jedoch das Recht vor, in Zukunft kostenpflichtige Abonnementpläne oder Servicegebühren einzuführen. Der Zugriff auf bestimmte Premium-Funktionen oder höhere Nutzungslimits kann ein kostenpflichtiges Abonnement erfordern. Nutzer werden im Voraus über alle obligatorischen Änderungen am Preismodell informiert.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">7. Datenbeständigkeit & Verlust</h3>
            <p>
                Obwohl wir angemessene Anstrengungen unternehmen, um die Sicherheit und Integrität Ihrer Daten zu gewährleisten, wird mealPai "wie besehen" und "nach Verfügbarkeit" bereitgestellt. Wir <strong>lehnen ausdrücklich jede Verantwortung oder Haftung für den Verlust von Daten ab</strong> (einschließlich Rezepten, Mahlzeitenplänen oder Kontoverlauf), der im Laufe der Zeit aufgrund technischer Fehler, Systemmigrationen, Datenbankfehlern oder Kontolöschung auftritt.
            </p>
            <p className="mt-2">
                Nutzern wird dringend empfohlen, regelmäßig die im Menü verfügbare Funktion <strong>"Daten exportieren"</strong> zu nutzen, um persönliche Backups ihrer Informationen zu erstellen.
            </p>
        </section>

        <section>
            <h3 className="text-lg font-bold text-slate-900 mb-2">8. Nutzung künstlicher Intelligenz (KI) und Haftungsausschluss</h3>
            <p>
                Die App (mealPai) nutzt Technologien der künstlichen Intelligenz (KI) zur Rezeptanalyse, Zutatenextraktion, Allergiewarnungen und personalisierten Mahlzeitenanalyse. Bitte beachten Sie, dass diese Technologie nicht fehlerfrei ist und gelegentlich falsche, unvollständige oder ungenaue Informationen liefern kann.
            </p>
            <p className="mt-2">
                Alle KI-generierten Inhalte werden als Empfehlung und ausschließlich zu Informationszwecken bereitgestellt. Nutzer müssen Vorsicht walten lassen und ihr eigenes unabhängiges Urteilsvermögen anwenden. Es liegt in der alleinigen Verantwortung des Nutzers, alle Zutaten und Allergiewarnungen (insbesondere bei schweren Allergien oder strengen Ernährungseinschränkungen) vor der Zubereitung oder dem Verzehr von Lebensmitteln manuell zu prüfen und zu verifizieren. Die Nutzung dieser Informationen erfolgt ausschließlich auf eigenes Risiko des Nutzers.
            </p>
        </section>
    </div>
);

export default TermsContent_de;
